module.exports = __webpack_public_path__ + "img/tg-icon.e4adb1ac.svg";